import { render, staticRenderFns } from "./productfiletable.vue?vue&type=template&id=3fb7f9f2&scoped=true&"
import script from "./productfiletable.vue?vue&type=script&lang=js&"
export * from "./productfiletable.vue?vue&type=script&lang=js&"
import style0 from "./productfiletable.vue?vue&type=style&index=0&id=3fb7f9f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb7f9f2",
  null
  
)

export default component.exports